import { useEffect, useState } from 'react';

/**
 * `true` a partir del breakpoint `md` de Tailwind (768px), que es donde la app
 * cambia de shell: aparece la sidebar y el contenido pasa a ser un panel
 * `fixed`. Reactivo (resize / rotación).
 *
 * Va acá y no se reusa `components/onboarding/useIsDesktop`: aquél corta en
 * 1024px, que es otro umbral y para otra cosa.
 */
const CONSULTA = '(min-width: 768px)';

export function useEsEscritorio(): boolean {
  const [esEscritorio, setEsEscritorio] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(CONSULTA).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(CONSULTA);
    const alCambiar = () => setEsEscritorio(mql.matches);
    alCambiar();
    mql.addEventListener('change', alCambiar);
    return () => mql.removeEventListener('change', alCambiar);
  }, []);

  return esEscritorio;
}

export default useEsEscritorio;
